<!-- En-tête page -->
<div class="page-title">
  <h2>Add a flight</h2>
  <button mat-mini-fab class="fab-compact add-btn" (click)="reset()" color="primary" aria-label="Create quickly">
    <mat-icon fontSet="material-symbols-outlined">refresh</mat-icon>
  </button>
</div>

<form class="container" [formGroup]="form" (ngSubmit)="onSubmit()">
  <!-- <mat-card class="card"> -->
  <!-- <div class="card-header"> -->
  <!-- <h2>Add a flight</h2> -->
  <!-- <button mat-icon-button type="button" aria-label="Reset" (click)="reset()">
    <mat-icon>refresh</mat-icon>
  </button> -->
  <!-- </div> -->

  <div class="line">
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Flight date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="date" required />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <!-- <mat-error *ngIf="form.get('date')?.hasError('required')"
          >Requis</mat-error
        > -->
    </mat-form-field>

    <app-autocomplete-editable
      class="ff-compact"
      [items]="aircrafts"
      [formControl]="aircraftCtrl"
      label="Aircraft"
      (selectionChange)="onAircraftSelected($event)"
    ></app-autocomplete-editable>

    <app-autocomplete-editable
      class="ff-compact"
      [items]="students"
      [formControl]="studentCtrl"
      label="Pilot"
      (selectionChange)="onPilotSelected($event)"
    ></app-autocomplete-editable>

    <app-autocomplete-editable
      class="ff-compact"
      [items]="instructors"
      [formControl]="instructorCtrl"
      label="Instructor"
      (selectionChange)="onInstructorSelected($event)"
    ></app-autocomplete-editable>

    <div *ngIf="instructorCtrl.value" style="display: flex; flex-direction: column; gap: 0.8rem" class="field">
      <mat-slide-toggle formControlName="pilotInCommand">Instructor is PIC</mat-slide-toggle>
      <mat-slide-toggle formControlName="recurrenceTraining">Competency check</mat-slide-toggle>
      <mat-slide-toggle formControlName="proficiencyCheck">Proficiency check</mat-slide-toggle>
    </div>
  </div>

  <h3 class="title">Invoicing</h3>

  <div class="line">
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Price</mat-label>
      <mat-select formControlName="priceCategory">
        <mat-option *ngFor="let c of priceCategories" [value]="c">{{ c }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Remarks</mat-label>
      <textarea matInput formControlName="remarks" rows="1"></textarea>
    </mat-form-field>
  </div>

  <h3 class="title">Times</h3>
  <div class="line">
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Origin (ICAO)</mat-label>
      <input matInput formControlName="origin" maxlength="4" (input)="forceIcaoUpper('origin')" required />
      <!-- <mat-error *ngIf="form.get('origin')?.invalid"
                >Code ICAO 4 alphanum</mat-error
                > -->
    </mat-form-field>

    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Destination (ICAO)</mat-label>
      <input matInput formControlName="destination" maxlength="4" (input)="forceIcaoUpper('destination')" required />
      <!-- <mat-error *ngIf="form.get('destination')?.invalid"
                >Code ICAO 4 alphanum</mat-error
                > -->
    </mat-form-field>

    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Counter start</mat-label>
      <input matInput formControlName="counterBeginText" (blur)="formatCounter('counterBeginText')" required />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Counter end</mat-label>
      <input matInput formControlName="counterEndText" (blur)="formatCounter('counterEndText')" required />
    </mat-form-field>
  </div>

  <div class="line">
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>TO</mat-label>
      <input matInput type="time" formControlName="takeoffTime" (blur)="computeOtherHours()" required />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Ldg</mat-label>
      <input matInput type="time" formControlName="landingTime" [readonly]="true" required />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Block Off</mat-label>
      <input matInput type="time" formControlName="blockOffTime" required />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Block On</mat-label>
      <input matInput type="time" formControlName="blockOnTime" required />
    </mat-form-field>
  </div>

  <div class="line">
    <div style="display: flex; flex-direction: column; row-gap: 1rem">
      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>Instr. time.</mat-label>
        <input matInput formControlName="instrumentTimeText" (blur)="formatCounter('instrumentTimeText')" required />
      </mat-form-field>
      <mat-slide-toggle [formControl]="allBtInstrumentTimeCtrl" class="field">All BT</mat-slide-toggle>
    </div>
    <div style="display: flex; flex-direction: column; row-gap: 1rem">
      <mat-form-field appearance="outline" class="ff-compact">
        <mat-label>Night time</mat-label>
        <input matInput formControlName="nightTimeText" (blur)="formatCounter('nightTimeText')" required />
      </mat-form-field>

      <mat-slide-toggle [formControl]="allBtNightTimeCtrl" class="field">All BT</mat-slide-toggle>
    </div>
  </div>

  <h3 class="title">Operations</h3>
  <div class="line">
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Oil (L)</mat-label>
      <input matInput type="number" step="0.1" formControlName="oilRefilled" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Fuel (L)</mat-label>
      <input matInput type="number" step="0.1" formControlName="fuelRefilled" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Pax</mat-label>
      <input matInput type="number" formControlName="passengers" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>MOUA</mat-label>
      <input matInput type="number" formControlName="moua" />
    </mat-form-field>
  </div>

  <section class="landings">
    <div class="catogory-title">
      <h3 class="title">Approachs / Landings</h3>
      <button mat-mini-fab color="primary" type="button" (click)="addLanding()" aria-label="Add an approach">
        <mat-icon>add</mat-icon>
      </button>
      <div style="margin-bottom: 1rem"></div>
    </div>

    <div formArrayName="landings" class="landing-list">
      <div *ngFor="let grp of landings.controls; let i = index" [formGroupName]="i" class="landing-row">
        <div class="line">
          <mat-form-field appearance="outline" class="ff-compact" style="--ff-width: 100px">
            <mat-label>Approach</mat-label>
            <mat-select formControlName="approachType" style="font-size: 13px" required>
              <mat-option value="VISUAL">VISUAL</mat-option>
              <mat-option value="PA_3D">PA 3D</mat-option>
              <mat-option value="NPA_2D">NPA 2D</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-checkbox formControlName="isNight">Night</mat-checkbox>

          <mat-form-field appearance="outline" class="ff-compact" style="--ff-width: 60px">
            <mat-label>Nb.</mat-label>
            <input matInput type="number" formControlName="count" min="0" required />
          </mat-form-field>

          <button mat-icon-button color="warn" type="button" aria-label="Supprimer" (click)="removeLanding(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>

  <div class="actions">
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || submitting()">Save</button>
    <button mat-button type="button" (click)="reset()">Cancel</button>
  </div>
  <!-- </mat-card> -->
</form>
